import type { RuntimeConfig } from '../game/types';
import { BUILD_INFO } from '../generated/buildInfo';

export const GAME_VERSION = BUILD_INFO.version;

export const DEFAULT_RUNTIME_CONFIG: RuntimeConfig = {
  academyUrl: 'https://turncom360.com/academy',
  eventName: 'Public Health & Broadband Summit',
  eventMode: true,
};

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  try {
    const response = await fetch('./config.json', { cache: 'no-store' });
    if (!response.ok) return DEFAULT_RUNTIME_CONFIG;
    const loaded = (await response.json()) as Partial<RuntimeConfig>;
    return {
      academyUrl: typeof loaded.academyUrl === 'string' ? loaded.academyUrl : DEFAULT_RUNTIME_CONFIG.academyUrl,
      eventName: typeof loaded.eventName === 'string' ? loaded.eventName : DEFAULT_RUNTIME_CONFIG.eventName,
      eventMode: typeof loaded.eventMode === 'boolean' ? loaded.eventMode : DEFAULT_RUNTIME_CONFIG.eventMode,
    };
  } catch {
    return DEFAULT_RUNTIME_CONFIG;
  }
}
